module.exports = __webpack_public_path__ + "img/logo.5271b933.png";